import { jsx as e } from "react/jsx-runtime";
import { Renderer as o } from "./styles.js";
function m({ imagesContent: r }) {
  return /* @__PURE__ */ e(o, { children: r });
}
export {
  m as ImagesList
};
